import { TaskFormDataModel } from "./TaskFormDataModel";

/**
 * * Модель создания задачи
 */
export class CreateTaskModel extends TaskFormDataModel {
  /**ID проекта */
  ProjectId!: number;
  /**ID очереди */
  QueueId!: string;
  /**ID автора */
  OwnerId!: number;
  IsMove: boolean = false;

  constructor(obj?: Partial<CreateTaskModel>) {
    super(obj);
    Object.assign(this, obj);
  }
}
